/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_down': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" d="M1.1 5l4.243 4.243L9.586 5" _stroke="#4F4F4F"/>'
  }
})
